// What the supplier document uploader accepts. Mirrors the BE's
// DOCUMENT_FILE_TYPE_REGEX: PDF plus JPEG/PNG/WebP, because trade licences reach
// ops as phone photos at least as often as scans.
//
// MIME-type-first, and this matters: `FileUploader` validates with
// `acceptedTypes.includes(file.type)`, and `File.type` is always a MIME type. An
// extension-only list rejects *every* file and `onUpload` never fires, which
// reads as a backend bug. The extensions below only widen the browse dialog.

/** Drives validation — must match `File.type` exactly. */
export const DOCUMENT_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'] as const;

/** Only widens the browse dialog's filter; never matches `File.type`. */
export const DOCUMENT_FILE_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png', '.webp'] as const;

export const DOCUMENT_ACCEPT_TYPES: string[] = [...DOCUMENT_MIME_TYPES, ...DOCUMENT_FILE_EXTENSIONS];

/** Matches the BE's MAX_DOCUMENT_SIZE_BYTES. FileUploader's own default is 5MB. */
export const MAX_DOCUMENT_FILE_SIZE = 10 * 1024 * 1024;

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
